import LeadersClubView from './LeadersClubView';

export default LeadersClubView;
